module.exports = __webpack_public_path__ + "img/d201311_4.318301cc.jpg";